import { __ } from '@wordpress/i18n';
import { BDevice, Label } from '../../../../Components';
import { PanelBody, PanelRow, SelectControl } from '@wordpress/components';
import { layoutOpt } from '../../utils/options';

const SettingsPanel = ({ device, setDevice, attributes, setAttributes }) => {
    const { layout } = attributes;
    return <>
        <PanelBody title={__('Settings', 'swipe-n-buy')} initialOpen={false}>
            <PanelRow>
                <Label className='mt0'>{__('Layout', 'swipe-n-buy')}</Label>
                <BDevice device={device} onChange={val => setDevice(val)} />
            </PanelRow>

            <SelectControl className='' options={layoutOpt} value={layout[device]} onChange={val => { setAttributes({ layout: { ...layout, [device]: val } }) }} />
        </PanelBody>
    </>
}
export default SettingsPanel;